(function () {
  'use strict';

  var modal;
  var contentEl;
  var unitsWrap;
  var lastTrigger;
  var currentUnit = 'cm';
  var currentChartId = '';
  var builtInCharts = {
    'vieno-dydzio-kostiumai': '<div class="size-chart"><div class="size-chart__scroll"><table class="size-chart__table"><thead><tr><th>Dydis</th><th>Ūgis</th><th>Krūtinė</th><th>Liemuo</th><th>Klubai</th></tr></thead><tbody><tr><td>Vienas dydis</td><td>171-188</td><td>95-113</td><td>80-96</td><td>96-112</td></tr><tr><td>XXL</td><td>189-191</td><td>114-119</td><td>97-111</td><td>113-118</td></tr></tbody></table></div></div>',
    'berniuku-kostiumai': '<div class="size-chart"><div class="size-chart__scroll"><table class="size-chart__table"><thead><tr><th>Dydis</th><th>Ūgis</th><th>Krūtinė</th><th>Liemuo</th><th>Klubai</th></tr></thead><tbody><tr><td>3-4 metai</td><td>101-104</td><td>53-56</td><td>51-54</td><td>57-60</td></tr><tr><td>5-6 metai</td><td>105-116</td><td>57-60</td><td>55-66</td><td>61-64</td></tr><tr><td>7-9 metai</td><td>117-134</td><td>61-69</td><td>57-61</td><td>65-74</td></tr><tr><td>10-12 metų</td><td>135-152</td><td>70-78</td><td>62-66</td><td>75-84</td></tr></tbody></table></div></div>',
    'mergaitisku-kostiumai': '<div class="size-chart"><div class="size-chart__scroll"><table class="size-chart__table"><thead><tr><th>Dydis</th><th>Ūgis</th><th>Krūtinė</th><th>Liemuo</th><th>Klubai</th></tr></thead><tbody><tr><td>2-3 metų</td><td>96-98</td><td>52-54</td><td>50-53</td><td></td></tr><tr><td>3-4 metų</td><td>100-104</td><td>54-56</td><td>53-54</td><td>56-60</td></tr><tr><td>5-6 metų</td><td>105-116</td><td>57-60</td><td>56-60</td><td>61-64</td></tr><tr><td>7-9 metų</td><td>117-134</td><td>61-69</td><td>57-61</td><td>65-74</td></tr><tr><td>10-12 metų</td><td>135-152</td><td>70-78</td><td>62-66</td><td>75-84</td></tr></tbody></table></div></div>',
    'vyrisku-kostiumai': '<div class="size-chart"><div class="size-chart__scroll"><table class="size-chart__table"><thead><tr><th>Dydis</th><th>Ūgis</th><th>Krūtinė</th><th>Liemuo</th><th>Klubai</th></tr></thead><tbody><tr><td>S</td><td>168-171</td><td>88-95</td><td>77-80</td><td>91-96</td></tr><tr><td>M</td><td>172-179</td><td>96-101</td><td>81-84</td><td>97-100</td></tr><tr><td>L</td><td>180-185</td><td>102-107</td><td>85-90</td><td>101-106</td></tr><tr><td>XL</td><td>186-188</td><td>108-113</td><td>91-96</td><td>107-112</td></tr><tr><td>XXL</td><td>189-191</td><td>114-119</td><td>97-111</td><td>113-118</td></tr><tr><td>XXXL</td><td>192-195</td><td>120-125</td><td>112-117</td><td>119-124</td></tr><tr><td>XXXXL</td><td>196-199</td><td>126-131</td><td>118-123</td><td>125-130</td></tr></tbody></table></div></div>',
    'suitmaster-vyriski-kostiumai': '<div class="size-chart"><div class="size-chart__scroll"><table class="size-chart__table"><thead><tr><th>Europinis dydis</th><th>Amerikietiškas dydis</th><th>Krūtinė</th><th>Liemuo</th><th>Klynas</th></tr></thead><tbody><tr><td>S</td><td>34–36</td><td>&lt;101</td><td>&lt;85</td><td>&lt;83</td></tr><tr><td>M</td><td>38–40</td><td>&lt;109</td><td>&lt;89</td><td>&lt;85</td></tr><tr><td>L</td><td>42–44</td><td>&lt;117</td><td>&lt;95</td><td>&lt;87</td></tr><tr><td>XL</td><td>44–48</td><td>&lt;128</td><td>&lt;104</td><td>&lt;89</td></tr><tr><td>XXL</td><td>50–52</td><td>&lt;136</td><td>&lt;109</td><td>&lt;91</td></tr></tbody></table></div><div class="size-chart__note"><strong>Labai svarbu</strong><ul><li>Matmenys pateikti centimetrais.</li><li>Šie matmenys taikomi asmeniui, nešiojančiam kostiumą, o ne pačiam kostiumui.</li><li>Ne kiekvienas kostiumas yra prieinamas visais dydžiais. Jei norite sužinoti galimus dydžius, patikrinkite produkto puslapį.</li><li>Jei esate labai aukštas arba abejojate tarp dviejų dydžių, rekomenduojame rinktis didesnį dydį.</li></ul></div></div>',
    'moteru-kostiumai': '<div class="size-chart"><div class="size-chart__scroll"><table class="size-chart__table"><thead><tr><th>Dydis</th><th>Ūgis</th><th>Krūtinė</th><th>Liemuo</th><th>Klubai</th></tr></thead><tbody><tr><td>XS</td><td></td><td>81-82</td><td>61-62</td><td>89-90</td></tr><tr><td>S</td><td></td><td>83-86</td><td>63-66</td><td>91-94</td></tr><tr><td>M</td><td>169-172</td><td>87-92</td><td>67-72</td><td>95-100</td></tr><tr><td>L</td><td>173-176</td><td>93-98</td><td>73-78</td><td>101-106</td></tr><tr><td>XL</td><td>177-182</td><td>99-104</td><td>79-85</td><td>107-112</td></tr><tr><td>XXL</td><td>183-188</td><td>105-108</td><td>86-90</td><td>113-116</td></tr><tr><td>XXXL</td><td>189-190</td><td>109-114</td><td>91-95</td><td>117-120</td></tr><tr><td>XXXXL</td><td>189-190</td><td>115-118</td><td>96-100</td><td>121-124</td></tr></tbody></table></div></div>',
    'moteriski-kostiumeliai': '<div class="size-chart"><div class="size-chart__scroll"><table class="size-chart__table"><thead><tr><th>Europinis dydis</th><th>Krūtinė</th><th>Liemuo</th><th>Klubai</th></tr></thead><tbody><tr><td>44</td><td>101</td><td>84</td><td>110</td></tr><tr><td>34</td><td>81</td><td>64</td><td>90</td></tr><tr><td>36</td><td>85</td><td>68</td><td>94</td></tr><tr><td>38</td><td>89</td><td>72</td><td>98</td></tr><tr><td>40</td><td>93</td><td>76</td><td>102</td></tr><tr><td>42</td><td>97</td><td>80</td><td>106</td></tr><tr><td>46</td><td>105</td><td>88</td><td>114</td></tr><tr><td>S</td><td>87</td><td>70</td><td>96</td></tr><tr><td>M</td><td>91</td><td>74</td><td>100</td></tr><tr><td>L</td><td>95</td><td>78</td><td>104</td></tr><tr><td>XL</td><td>99</td><td>82</td><td>108</td></tr></tbody></table></div><div class="size-chart__note"><strong>Labai svarbu</strong><ul><li>Matmenys pateikti centimetrais.</li><li>Šie matmenys taikomi asmeniui, nešiojančiam kostiumą, o ne pačiam kostiumui.</li><li>Ne kiekvienas kostiumas yra prieinamas visais dydžiais. Jei norite sužinoti galimus dydžius, patikrinkite produkto puslapį.</li><li>Jei abejojate tarp dviejų dydžių, rekomenduojame rinktis didesnį dydį.</li></ul></div></div>',
    'default': '<div class="size-chart"><div class="size-chart__scroll"><table class="size-chart__table"><thead><tr><th>Dydis</th><th>Ūgis</th><th>Krūtinė</th><th>Liemuo</th><th>Klubai</th></tr></thead><tbody><tr><td>XS</td><td></td><td>81-82</td><td>61-62</td><td>89-90</td></tr><tr><td>S</td><td></td><td>83-86</td><td>63-66</td><td>91-94</td></tr><tr><td>M</td><td>169-172</td><td>87-92</td><td>67-72</td><td>95-100</td></tr><tr><td>L</td><td>173-176</td><td>93-98</td><td>73-78</td><td>101-106</td></tr><tr><td>XL</td><td>177-182</td><td>99-104</td><td>79-85</td><td>107-112</td></tr><tr><td>XXL</td><td>183-188</td><td>105-108</td><td>86-90</td><td>113-116</td></tr><tr><td>XXXL</td><td>189-190</td><td>109-114</td><td>91-95</td><td>117-120</td></tr><tr><td>XXXXL</td><td>189-190</td><td>115-118</td><td>96-100</td><td>121-124</td></tr></tbody></table></div></div>'
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function normalizeId(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getDefaultChartId() {
    return normalizeId(window.sizeChartDefault || 'moteru-kostiumai');
  }

  function ensureModal() {
    modal = document.getElementById('size-chart-modal');

    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'size-chart-modal';
      modal.id = 'size-chart-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = '<div class="size-chart-modal__backdrop" data-size-chart-close></div><div class="size-chart-modal__dialog" role="document"><div class="size-chart-modal__header"><div class="size-chart-units" role="tablist" aria-label="Matavimo vienetai"><span class="size-chart-units__label">Matavimo vienetai:</span><button type="button" class="size-chart-units__btn is-active" data-unit="cm">cm</button><button type="button" class="size-chart-units__btn" data-unit="in">in</button></div><button type="button" class="size-chart-modal__close" data-size-chart-close aria-label="Uždaryti"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg></button></div><div class="size-chart-modal__content" data-size-chart-content></div></div>';
    }

    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    contentEl = modal.querySelector('[data-size-chart-content]');
    unitsWrap = modal.querySelector('.size-chart-units');
    return modal;
  }

  function keepTriggersClickable() {
    var triggers = document.querySelectorAll('[data-size-chart-trigger]');
    Array.prototype.forEach.call(triggers, function (trigger) {
      trigger.setAttribute('type', 'button');
      trigger.style.pointerEvents = 'auto';
      trigger.style.cursor = 'pointer';
      trigger.style.zIndex = '2147483000';
      if (trigger.parentNode !== document.body) document.body.appendChild(trigger);
    });
  }

  function findTemplate(chartId) {
    var wanted = normalizeId(chartId);
    var defaultId = getDefaultChartId();
    var tpls = document.querySelectorAll('template[data-size-chart]');
    var first = null;
    var defaultTpl = null;

    for (var i = 0; i < tpls.length; i++) {
      var id = normalizeId(tpls[i].getAttribute('data-size-chart'));
      if (!first) first = tpls[i];
      if (id === wanted) return tpls[i];
      if (id === defaultId || id === 'default') defaultTpl = tpls[i];
    }

    return defaultTpl || first;
  }

  function toInches(text) {
    return String(text).replace(/(\d+(?:[.,]\d+)?)/g, function (match) {
      var number = parseFloat(match.replace(',', '.')) / 2.54;
      return (Math.round(number * 10) / 10).toString().replace('.', ',');
    });
  }

  function convertTableToInches(root) {
    var rows = root.querySelectorAll('tbody tr');
    Array.prototype.forEach.call(rows, function (tr) {
      Array.prototype.forEach.call(tr.children, function (td, index) {
        if (index === 0) return;
        td.textContent = toInches(td.textContent);
      });
    });
  }

  function renderTable(chartId, unit) {
    ensureModal();
    if (!contentEl) return;

    var wanted = normalizeId(chartId) || getDefaultChartId();
    var tpl = findTemplate(wanted);
    var html = '';
    contentEl.innerHTML = '';

    if (tpl && tpl.content) {
      var clone = tpl.content.cloneNode(true);
      if (unit === 'in') convertTableToInches(clone);
      contentEl.appendChild(clone);
    } else {
      html = builtInCharts[wanted] || builtInCharts[getDefaultChartId()] || builtInCharts.default;
      contentEl.innerHTML = html;
      if (unit === 'in') convertTableToInches(contentEl);
    }

    currentChartId = wanted;
    contentEl.setAttribute('data-current-chart', currentChartId);
  }

  function updateUnitButtons() {
    ensureModal();
    if (!unitsWrap) return;
    Array.prototype.forEach.call(unitsWrap.querySelectorAll('.size-chart-units__btn'), function (button) {
      button.classList.toggle('is-active', button.getAttribute('data-unit') === currentUnit);
    });
  }

  function openChart(chartId, triggerEl) {
    ensureModal();
    currentUnit = 'cm';
    lastTrigger = triggerEl || document.activeElement;
    updateUnitButtons();
    renderTable(chartId, currentUnit);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('size-chart-open');
    document.body.classList.add('size-chart-open');
    var closeBtn = modal.querySelector('.size-chart-modal__close');
    if (closeBtn && closeBtn.focus) closeBtn.focus();
  }

  function closeChart() {
    ensureModal();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('size-chart-open');
    document.body.classList.remove('size-chart-open');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function handleInteraction(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-size-chart-trigger]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openChart(trigger.getAttribute('data-size-chart-trigger'), trigger);
      return;
    }

    if (target.closest('[data-size-chart-close]')) {
      event.preventDefault();
      closeChart();
      return;
    }

    var unitBtn = target.closest('.size-chart-units__btn');
    if (unitBtn && modal && modal.classList.contains('is-open')) {
      event.preventDefault();
      currentUnit = unitBtn.getAttribute('data-unit') || 'cm';
      updateUnitButtons();
      renderTable(currentChartId || (contentEl ? contentEl.getAttribute('data-current-chart') : ''), currentUnit);
    }
  }

  window.teminisSizeChartOpen = openChart;
  window.teminisSizeChartClose = closeChart;

  if (!window.__sizeChartInit) {
    window.__sizeChartInit = true;
    document.addEventListener('pointerdown', handleInteraction, true);
    document.addEventListener('click', handleInteraction, true);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) closeChart();
    });
  }

  ready(function () {
    ensureModal();
    keepTriggersClickable();
  });
})();
